import React from 'react';
import Layout from './layout';
import { useDispatch } from 'react-redux';
import { setAuthorize } from '../store/authorization/thunk/setAuthorize';
import axios from 'axios';

const Mobile = () => {
    const dispatch = useDispatch();
    const token = localStorage.getItem('token')
    axios.defaults.headers.common['Authorization'] = token;
    
    React.useEffect(() => {
        if (token) {
            dispatch(setAuthorize())
        }
    }, [token])

    return (
        <div style={{background: '#141b33', width: '100%', height: '100%'}}>
            <Layout />
        </div>
    )
}

export default Mobile;